(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
document.getElementById("contactForm").addEventListener("submit", function(e){
  e.preventDefault();

  // Hide form and show thank you
  this.style.display = "none";
  document.getElementById("thankYouMessage").style.display = "block";

  // After 1 second, reset form and show again
  setTimeout(function(){
    document.getElementById("thankYouMessage").style.display = "none";
    document.getElementById("contactForm").reset();
    document.getElementById("contactForm").style.display = "block";
  }, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
